import { useContext } from 'react';
import type { WorkspaceObject, WorkspaceObjectTreeItem, Workspace } from '@/types';
import { createNamedContext } from '@trinity/chat-components';

export type MoveObjectContextValue = {
  currentPath: string[];
  data: WorkspaceObjectTreeItem;
  object: WorkspaceObject;
  loadingTree?: boolean;
  isSaving: boolean;
  onSave: () => Promise<unknown>;
  onSelectParentObject: (id: number) => unknown;
  parentObjectId: number;
};

export type WorkspaceInfo = Pick<Workspace, 'id' | 'name' | 'objectId'>;

export type MoveObjectWorkspaceContextValue = {
  loadingWorkspaces?: boolean;
  onSelectWorkspace: (value: WorkspaceInfo) => unknown;
  selectedWorkspace: WorkspaceInfo;
  workspaces: WorkspaceInfo[];
};

export const WorkspaceBreadcrumbsContext = createNamedContext<WorkspaceObject[]>(undefined, 'Workspace.Breadcrumbs.Context');
export const MoveObjectContext = createNamedContext<MoveObjectContextValue>(undefined, 'Move.Object.Context');
export const MoveObjectWorkspaceContext = createNamedContext<MoveObjectWorkspaceContextValue>(undefined, 'Move.Object.Workspace.Context');

export const useObjectBreadcrumbsContext = () => useContext(WorkspaceBreadcrumbsContext);